import type { Event } from '@patsnap/tahiti-core';
import type { FtoReportFeatureRecognizeResult } from './feature-identify';

/**
 * 原始输入获取服务
 * @description 用于获取原始输入，并更新到模型 {@link FtoReportRetrievalResultReportModel}
 */
export interface FtoReportOriginalInputService {
    /**
     * 获取原始输入，并更新到模型 {@link FtoReportRetrievalResultReportModel}
     * @returns 原始输入
     */
    pullOriginalInput(): Promise<string>;
}

export const FtoReportOriginalInputService = Symbol.for('FtoReportOriginalInputService');

/**
 * 获取技术特征服务
 * @description 用于获取技术特征，并更新到模型 {@link FtoReportRetrievalResultReportModel}
 */
export interface FtoReportTechFeaturesService {
    /**
     * 获取技术特征
     * @returns 技术特征
     */
    pullTechFeatures(): Promise<FtoReportFeatureRecognizeResult>;
}

export const FtoReportTechFeaturesService = Symbol.for('FtoReportTechFeaturesService');

/**
 * 新颖性报告名称服务
 */
export interface FtoReportTitleService {
    /**
     * 获取新颖性报告名称，并更新到模型 {@link FtoReportRetrievalResultReportModel}
     * @returns 新颖性报告名称
     */
    pullNoveltyCheckReportTitle(): Promise<string>;
}

export const FtoReportTitleService = Symbol.for('FtoReportTitleService');

/**
 * 评述报告服务
 */
export interface FtoReportNoveltyReviewService {
    /**
     * 评述报告加载事件
     */
    onNoveltyReviewLoading: Event<boolean>;
}

export const FtoReportNoveltyReviewService = Symbol.for('FtoReportNoveltyReviewService');

/**
 * 对比文献公开情况服务
 */
export interface FtoReportComparativeLiteraturePublicityService {
    /**
     * 对比文献公开情况加载事件
     */
    onComparativeLiteraturePublicityLoading: Event<boolean>;
}

export const FtoReportComparativeLiteraturePublicityService = Symbol.for('FtoReportComparativeLiteraturePublicityService');

/**
 * 技术要点更新服务
 */
export interface FtoReportTechEssentialService {
    /**
     * 获取技术要点
     * @returns 技术要点
     */
    pullTechEssential(): Promise<string>;
    /**
     * 更新技术要点
     * @param techEssential 技术要点
     */
    updateTechEssential(techEssential: string): Promise<void>;
}

export const FtoReportTechEssentialService = Symbol.for('FtoReportTechEssentialService');

/**
 * 检索结果报告副标题信息服务
 */
export interface FtoReportRetrievalResultReportSubtitleInfoService {
    /**
     * 获取检索结果报告副标题信息
     */
    pullRetrievalResultReportSubtitleInfo(): Promise<void>;
}

export const FtoReportRetrievalResultReportSubtitleInfoService = Symbol.for('FtoReportRetrievalResultReportSubtitleInfoService');
